"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PackagingSolutionCoreDisplay() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="107690" id="开启高效听力之旅" className="bg-background text-foreground relative overflow-hidden min-h-[90vh] flex items-center py-20 lg:py-0">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/10 via-background to-background -z-10" />
      
      {}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoMCwgMCwgMCwgMC4wMikiLz48L3N2Zz4=')] opacity-50 -z-10" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="inline-flex items-center rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5 text-sm font-bold text-primary backdrop-blur-sm">
              <span className="flex h-2.5 w-2.5 rounded-full bg-primary mr-2 animate-pulse"></span>
              AI 智能助学 · 听力革命
            </div>
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-slate-700 leading-[1.1]">
              听不懂英语？<br />
              <span className="text-primary relative inline-block">
                一句一句
                <svg className="absolute -bottom-2 left-0 w-full h-3 text-primary/30" viewBox="0 0 100 10" preserveAspectRatio="none">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="6" fill="transparent" />
                </svg>
              </span>
              练到听懂
            </h1>
            
            <p className="text-lg md:text-xl text-slate-500 max-w-2xl leading-relaxed font-medium">
              AI 逐句精听 + 智能记忆系统，让听力真正提升。不再为连读、失爆而困扰，让每一个单词都清晰入耳，轻松攻克语言障碍。
            </p>
            
            <div className="pt-4 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <div className="relative inline-flex group">
                {}
                <div className="absolute -inset-1 bg-primary rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                <Button asChild size="lg" className="relative h-14 px-10 text-lg font-bold rounded-2xl shadow-xl bg-emerald-500 hover:bg-emerald-600 text-white border-b-4 border-emerald-700 active:border-b-0 active:translate-y-1 transition-all">
                  <Link to="/DownloadCenterPage">
                    免费下载
                  </Link>
                </Button>
              </div>
              
              <Button asChild variant="outline" size="lg" className="h-14 px-10 text-lg font-bold rounded-2xl border-2 border-sky-400 text-sky-600 hover:bg-sky-50 transition-colors">
                <Link to="/OnlineAppPage">
                  在线体验
                </Link>
              </Button>
            </div>
            
            {}
            <div className="pt-8 flex items-center gap-6 text-sm font-bold text-slate-400 border-t border-slate-100 w-full max-w-md">
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
                AI 逐句拆解
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
                中英对照
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
                循环精听
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative mt-12 lg:mt-0 transition-all duration-1000 delay-300 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="relative z-20 lg:-ml-24 xl:-ml-32">
              {}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-sky-400/10 blur-[100px] rounded-full -z-10 pointer-events-none" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618423/img/premium_custom_shipping_box_3d_render.png" alt="听力通 App 智能学习界面展示" className="w-full h-auto object-contain drop-shadow-2xl transform hover:rotate-2 transition-transform duration-700 ease-out" />
              
              {}
              <div className="absolute bottom-10 -left-6 md:left-0 bg-white/95 backdrop-blur-md border-2 border-slate-100 p-5 rounded-3xl shadow-2xl animate-bounce" style={{
              animationDuration: '4s'
            }}>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-emerald-100 flex items-center justify-center">
                    <svg className="w-6 h-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">智能学习</p>
                    <p className="text-base font-bold text-slate-700">AI 逐句精听系统</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}